import { SubHeading } from "../../components";
import { images } from "../../constants";

const FindUs = () => (
  <div className="app__bg app__wrapper section__padding" id="contact">
    <div className="app__wrapper_info">
      <SubHeading title="Contact" />
      <h1 className="headtext__cormorant" style={{ marginBottom: "3rem" }}>
        Hitta Oss
      </h1>
      <div className="app__wrapper-content">
        <p className="p__opensans">Östra Torggatan 6, 652 24 Karlstad</p>
        <p
          className="p__cormorant"
          style={{ color: "#DCCA87", margin: "2rem 0" }}
        >
          Öppettider
        </p>
        <p className="p__opensans">Mån - Fre: 10:00 - 02:00</p>
        <p className="p__opensans">Lör - Sön: 10:00 - 03:00</p>
      </div>
      <button
        type="button"
        className="custom__button"
        style={{ marginTop: "2rem" }}
      >
        Besök oss
      </button>
    </div>

    <div className="app__wrapper_img">
      <img src={images.findus} alt="finus_img" />
    </div>
  </div>
);

export default FindUs;
